import React from 'react';
import { LogoutIcon } from '@deliveryhero/armor-icons';
import { HeaderNavigationActionItem } from '.';
import { getWindow } from '../../../system/util/globals';

var setURL = function setURL() {
  var win = getWindow();

  if (win) {
    win.location.assign('/users/sign_out');
  }
};

export var HeaderNavigationActionLogisticsSignOutButton = function HeaderNavigationActionLogisticsSignOutButton(_ref) {
  var restProps = Object.assign({}, _ref);
  return React.createElement(HeaderNavigationActionItem, Object.assign({}, restProps, {
    onClick: setURL
  }), React.createElement(LogoutIcon, null));
};